import { useEffect, useState } from 'react';
import styled from 'styled-components';
import moment from 'moment';

import FetchModule from '../../../../Share/Network/FetchModule';
import { useLanguage } from '../../../../../Context/LanguageContext';
import { useTheme } from '../../../../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../../../../Styles/theme';
import TotalModalWrapper from '../../../../Share/Normal/TotalModalWrapper';

export default function LockerUsageStopModal(props) {
  const { data, lockerRendering, onClickExit } = props;
  const { t } = useLanguage();
  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;

  const [usageDayText, setUsageDayText] = useState('');

  // Init Data Setting //
  useEffect(() => {
    if (moment(data.endDate).format('YYYY.MM.DD') > moment().format('YYYY.MM.DD')) setUsageDayText(t('memberDetail.lockerStopConfirm1') + (moment(data.endDate).diff(moment(), 'days') + 1) + t('memberDetail.lockerStopDaysLeft'));
    else if (moment(data.endDate).format('YYYY.MM.DD') === moment().format('YYYY.MM.DD')) setUsageDayText(t('memberDetail.lockerStopEndToday'));
    else return setUsageDayText(t('memberDetail.lockerStopConfirm1') + (moment().diff(moment(data.endDate), 'days') + 1) + t('memberDetail.lockerStopDaysOver'));
  }, [data])

  // 삭제 버튼 클릭시 //
  function deleteClick() {
    // const fetchModule = new FetchModule();
    // (
    //   async () => {
    //     const responseData = await fetchModule.postData('locker/stop/' + data.lockerId, 'POST');

    //     if (responseData.status === 200) {
    //       alert('사용 종료가 완료되었습니다!');
    //       lockerRendering();
    //       onClickExit();
    //     }
    //     else if (responseData.status === 204) { }
    //   }
    // )();
    let requestData = {
      usageId: data.usageId
    }

    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postDataVersion2('locker/stop/', 'POST', requestData);

        if (responseData.status === 200) {
          alert(t('memberDetail.alertLockerStopComplete'));
          lockerRendering();
          onClickExit();
        }
        else if (responseData.status === 204) { }
      }
    )();
  }

  return (
    <TotalModalWrapper onClickExit={onClickExit}>
      <ModalView $isDark={isDark}>
        <TitleWrapper>
          <Text fontFamily='NotoSansKR-Bold' fontSize={16} color={theme.text} cursor='default'>{t('memberDetail.lockerStopTitle')}</Text>
          <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={theme.subText} cursor='default'>{data.lockerName + t('memberDetail.lockerStopDesc')}</Text>
        </TitleWrapper>
        <TextWrapper>
          <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.text} cursor='default'>{t('memberDetail.lockerStopConfirm1') + data.userName + t('memberDetail.lockerStopConfirm2')}</Text>
          <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.text} cursor='default'>{usageDayText}</Text>
        </TextWrapper>
        <ButtonWrapper>
          <ExitButton onClick={onClickExit}>
            <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.text} cursor='pointer'>{t('memberDetail.modalCancel')}</Text>
          </ExitButton>
          <CancelButton onClick={deleteClick}>
            <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.subBackground} cursor='pointer'>{t('memberDetail.modalEndBtn')}</Text>
          </CancelButton>
        </ButtonWrapper>
      </ModalView>
    </TotalModalWrapper>
  )
}

const ModalView = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: flex-start;

  padding: 20px;

  border-radius: 10px;
  box-shadow: ${props => props.$isDark ? 'none' : '0px 40px 50px rgba(0, 0, 0, 0.1)'};
  background-color: ${props => props.theme.subBackground};
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 100%;

  gap: 4px;
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;

  margin-top: 30px;

  gap: 8px;
`;

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-end;
  align-items: center;

  margin-top: 30px;

  width: 100%;

  gap: 10px;
`;

const ExitButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 62px;
  height: 40px;

  border-radius: 10px;
  background-color: ${props => props.theme.buttonFill};

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      cursor: pointer;
    }
  }

  transition: all 0.3s ease-in-out;
`;

const CancelButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 100px;
  height: 40px;

  border-radius: 10px;
  background-color: ${props => props.theme.pointRed};

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      cursor: pointer;
    }
  }

  transition: all 0.3s ease-in-out;
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      cursor: ${props => props.cursor};
    }
  }
`;
